module.exports = __webpack_public_path__ + "static/media/i_sk.e0fb2ae5.pdf";